export default __webpack_public_path__ + "static/media/contact-avatar-dark.9f025578.png";